import { CancelToken } from 'axios';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../store';
import { certificateListActions, getCertificateList, selectCertificateList } from '../../store/entities/certificateList';
import { getLangNameObj } from '../../utils/format';
import { QcsTableCell } from '../common/basic/QcsTableCell';
import { CellYesNo } from '../common/grid/CellYesNo';
import { Grid } from '../common/grid/Grid';
import { SectionHeader } from '../common/SectionHeader';
import { DocumentFilter } from './DocumentFilter';
import { CertificateDto } from '@api/models/suppliers/CertificateDto';

export const Documents: FC = () => {
  const { t, i18n } = useTranslation();
  const certificateList = useAppSelector(selectCertificateList);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleGetData = (cancelToken: CancelToken) => {
    dispatch(getCertificateList(cancelToken));
  };

  const handleRenderData = (item: CertificateDto) => {
    return (
      <>
        <QcsTableCell>{getLangNameObj(i18n, item)}</QcsTableCell>
        <CellYesNo value={item.expiryDateRequired} hideOnMobile={true} />
        <QcsTableCell hideOnMobile={true}>{t('entityState.' + item.state)}</QcsTableCell>
      </>
    );
  };

  const handleRowClick = (item: CertificateDto) => {
    navigate('/documents/' + item.id);
  };

  const handleAddClick = () => {
    navigate('/documents/new');
  };

  return (
    <>
      <SectionHeader title="document.title" addText="document.add" handleAddClick={handleAddClick} />
      <Grid<CertificateDto>
        headers={[
          { captionStr: 'document.name' },
          {
            captionStr: 'document.expiryDateRequired',
            hideOnMobile: true,
          },
          {
            captionStr: 'document.state',
            hideOnMobile: true,
          },
        ]}
        data={certificateList}
        gridActions={certificateListActions}
        renderData={handleRenderData}
        onRowClick={handleRowClick}
        getData={handleGetData}
        filter={<DocumentFilter query={certificateList.query} />}
      />
    </>
  );
};
